import { connect } from "react-redux";
import { mapStateToClubProps, mapDispatchToClubProps } from "../mapToProps"; 
import { BookClubWrapperView } from "../views/bookClubWrapperView";

export const ClubPresenter = connect(
    mapStateToClubProps,
    mapDispatchToClubProps,
)(BookClubWrapperView)
